
<div class="category-slider-row" fxLayout="column" *ngIf="!dataLoading">

  <div fxLayout="row" fxLayoutAlign="start stretch">
<div><span class="carousel-title">{{thisCategory.title}} - {{thisCategory.fileCount}} Files</span></div>
  <button mat-menu-item color="primary" class="catories-children-all" [routerLink]="['/products', thisCategory.id]">
        See All
      </button>
    </div>
<app-product-carousel fxFlex="0 0 100%" [items]="files" [configurationInput]="config" (indexChange)="indexChangeHandler($event)"></app-product-carousel>

</div>



// WEBPACK FOOTER //
// ./src/app/home-page/category/category.component.html